import { env } from "@/src/env.mjs";
import { useTheme } from "next-themes";

type LangfuseIconThemedProps = {
  size?: number;
  className?: string;
};

export const LangfuseIconThemed = ({
  size = 32,
  className,
}: LangfuseIconThemedProps) => {
  const { resolvedTheme } = useTheme();
  const iconPath =
    resolvedTheme === "dark"
      ? `${env.NEXT_PUBLIC_BASE_PATH ?? ""}/icon-dropsolid-dark-theme.svg`
      : `${env.NEXT_PUBLIC_BASE_PATH ?? ""}/icon-dropsolid-light-theme.svg`;

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={iconPath}
      width={size}
      height={size}
      alt="Langfuse Icon"
      className={className}
    />
  );
};
